// axiosInstance.js
import axios from "axios";
const backendUrl = window.env.BACKEND_URL ? window.env.BACKEND_URL : window.location.origin;
const requestId = crypto.randomUUID();
const axiosInstance = axios.create({
  baseURL: `${backendUrl}/api/v1`,//"https://mrt-be-exp-mrt-dev.apps.czchooct002.dhl.com/api",//"https://mrt-exp-mrt-dev.apps.czchooct002.dhl.com/api",
  headers: {
    'X-Request-ID': requestId,
  },
});

export default axiosInstance;
